export default __webpack_public_path__ + "static/media/h_top-4.15f5cb0f.svg";